module.exports = __webpack_public_path__ + "img/2.4172a145.jpg";